// Мобільна локалізація - JavaScript логіка
document.addEventListener('DOMContentLoaded', function() {
  
  function openLocalizationDrawer() {
    // Знаходимо кнопку локалізації
    const localizationButton = document.querySelector('.drawer-localization__button');
    if (localizationButton) {
      localizationButton.click();
      return;
    }

    // Альтернативно, якщо є dropdown локалізація
    const dropdownButton = document.querySelector('.dropdown-localization__button');
    if (dropdownButton) {
      dropdownButton.click();
      return;
    }

    // Створюємо модальне вікно з вибором мови та валюти
    createLanguageCurrencyModal();
  }

  function createLanguageCurrencyModal() {
    // Видаляємо існуючий модал, якщо є
    const existingModal = document.getElementById('mobile-localization-modal');
    if (existingModal) {
      existingModal.remove();
    }

    // Створюємо модальне вікно
    const modal = document.createElement('div');
    modal.id = 'mobile-localization-modal';
    modal.innerHTML = `
      <div class="modal-overlay" onclick="closeMobileLocalizationModal()">
        <div class="modal-content" onclick="event.stopPropagation()">
          <div class="modal-header">
            <h3>Мова та валюта</h3>
            <button onclick="closeMobileLocalizationModal()" class="close-button">&times;</button>
          </div>
          <div class="modal-body">
            <div class="language-section">
              <h4>Мова</h4>
              <div class="language-options">
                <button onclick="changeLanguageAndCurrency('ua', 'UAH')" class="option-button">
                  🇺🇦 Українська (UAH)
                </button>
                <button onclick="changeLanguageAndCurrency('en', 'EUR')" class="option-button">
                  🇬🇧 English (EUR)
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    // Додаємо стилі для модального вікна
    if (!document.getElementById('mobile-localization-styles')) {
      const styles = document.createElement('style');
      styles.id = 'mobile-localization-styles';
      styles.textContent = `
        #mobile-localization-modal .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }

        #mobile-localization-modal .modal-content {
          background: white;
          border-radius: 12px;
          width: 100%;
          max-width: 400px;
          max-height: 80vh;
          overflow-y: auto;
        }

        #mobile-localization-modal .modal-header {
          padding: 20px;
          border-bottom: 1px solid #eee;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        #mobile-localization-modal .modal-header h3 {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
        }

        #mobile-localization-modal .close-button {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          padding: 0;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        #mobile-localization-modal .modal-body {
          padding: 20px;
        }

        #mobile-localization-modal .language-section h4 {
          margin: 0 0 15px 0;
          font-size: 16px;
          font-weight: 500;
        }

        #mobile-localization-modal .language-options {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        #mobile-localization-modal .option-button {
          padding: 15px;
          border: 1px solid #ddd;
          border-radius: 8px;
          background: white;
          cursor: pointer;
          text-align: left;
          font-size: 16px;
          transition: all 0.2s ease;
        }

        #mobile-localization-modal .option-button:hover {
          border-color: #007bff;
          background-color: #f8f9fa;
        }
      `;
      document.head.appendChild(styles);
    }

    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
  }

  function closeMobileLocalizationModal() {
    const modal = document.getElementById('mobile-localization-modal');
    if (modal) {
      modal.remove();
      document.body.style.overflow = '';
    }
  }

  function changeLanguageAndCurrency(language, currency) {
    // Логіка зміни мови та валюти
    console.log(`Зміна мови на: ${language}, валюти на: ${currency}`);
    
    // Створюємо форму для зміни локалізації
    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/localization';
    form.style.display = 'none';
    
    // Додаємо поле для мови
    const languageInput = document.createElement('input');
    languageInput.type = 'hidden';
    languageInput.name = 'language_code';
    languageInput.value = language;
    form.appendChild(languageInput);
    
    // Додаємо поле для країни/валюти
    const countryInput = document.createElement('input');
    countryInput.type = 'hidden';
    countryInput.name = 'country_code';
    // Встановлюємо країну відповідно до валюти
    countryInput.value = currency === 'UAH' ? 'UA' : 'DE'; // DE для EUR
    form.appendChild(countryInput);
    
    // Додаємо return_to для повернення на ту ж сторінку
    const returnInput = document.createElement('input');
    returnInput.type = 'hidden';
    returnInput.name = 'return_to';
    returnInput.value = window.location.pathname + window.location.search;
    form.appendChild(returnInput);
    
    document.body.appendChild(form);
    
    // Закриваємо модал перед відправкою
    closeMobileLocalizationModal();
    
    // Показуємо повідомлення про зміну
    showSuccessMessage(`Зміна мови на ${language === 'ua' ? 'українську' : 'англійську'}, валюта: ${currency}`);
    
    // Відправляємо форму
    setTimeout(() => {
      form.submit();
    }, 500);
  }

  function showSuccessMessage(message) {
    const toast = document.createElement('div');
    toast.textContent = message;
    toast.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #28a745;
      color: white;
      padding: 12px 20px;
      border-radius: 6px;
      z-index: 10000;
      font-size: 14px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    `;
    
    document.body.appendChild(toast);
    
    setTimeout(() => {
      toast.remove();
    }, 3000);
  }

  // Робимо функції глобальними для onclick
  window.openLocalizationDrawer = openLocalizationDrawer;
  window.closeMobileLocalizationModal = closeMobileLocalizationModal;
  window.changeLanguageAndCurrency = changeLanguageAndCurrency;
});